module.exports = __webpack_public_path__ + "static/media/rectangleIcon.b8495ffb.svg";